import _slicedToArray from "/app/vetiver/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useState, useMemo } from 'react';
var TIMEOUT_EQUATION = 48 * 60 * 60 * 1000;

var useCountDown = function useCountDown(accountCreatedDate) {
  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      now = _useState2[0],
      setNow = _useState2[1];

  var end = new Date(accountCreatedDate).getTime() + TIMEOUT_EQUATION;
  var time = useMemo(function () {
    if (now) {
      var diff = Math.max((end - now) / 1000, 0);
      var hours = Math.floor(diff / 3600);
      var minutes = Math.floor((diff - hours * 3600) / 60);
      var diffInSeconds = Math.max(Math.floor((end - now) / 1000), 0);
      return {
        diff: diff,
        diffInSeconds: diffInSeconds,
        hours: hours,
        minutes: minutes
      };
    }
  }, [end, now]);
  useEffect(function () {
    var loop = setInterval(function () {
      return setNow(new Date().getTime());
    }, 1000);
    return function () {
      return clearInterval(loop);
    };
  }, []);
  return time;
};

export default useCountDown;